import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Landmark, Plus, Eye, Pencil, ExternalLink, Trash2 } from "lucide-react";
import { getRiskBadge } from "./helpers";

export const OthersTab = ({ othersOpps, openDetail, openEdit, confirmDelete, isDemo, setFormData, setIsAddOpen }) => {
  return (
    <>
      <div className="flex items-center justify-between">
        <p className="text-sm text-muted-foreground">Your custom investment opportunities. Click "Add Manual" to create one.</p>
        <p className="text-sm text-muted-foreground font-mono">{othersOpps.length} listing{othersOpps.length !== 1 ? "s" : ""}</p>
      </div>
      {othersOpps.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="others-grid">
          {othersOpps.map((opp, index) => (
            <Card key={opp.opportunity_id || index} className="overflow-hidden group hover:border-primary/40 transition-colors" data-testid={`others-card-${index}`}>
              {opp.image_url && (<div className="h-28 overflow-hidden bg-secondary/30"><img src={opp.image_url} alt="" className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity" loading="lazy" /></div>)}
              <CardContent className={`${opp.image_url ? "pt-4" : "pt-6"} pb-4 space-y-3`}>
                <div><h3 className="font-bold text-sm">{opp.name}</h3>{opp.description && <p className="text-xs text-muted-foreground mt-0.5">{opp.description}</p>}</div>
                <div className="flex flex-wrap gap-1.5">
                  {opp.custom_type && <Badge variant="outline" className="text-[10px]">{opp.custom_type}</Badge>}
                  <Badge variant="outline" className="text-[10px] font-mono">{opp.currency || "USD"}</Badge>
                  {getRiskBadge(opp.risk_score)}
                </div>
                <div className="grid grid-cols-2 gap-2 text-xs">
                  {opp.expected_return && (<div className="p-2 bg-secondary/50 rounded"><p className="text-muted-foreground">Expected Return</p><p className="font-mono font-bold text-green-500">{opp.expected_return}</p></div>)}
                  {opp.price && (<div className="p-2 bg-secondary/50 rounded"><p className="text-muted-foreground">Price</p><p className="font-mono font-bold">{opp.price}</p></div>)}
                  {opp.ticket && (<div className="p-2 bg-secondary/50 rounded"><p className="text-muted-foreground">Ticket</p><p className="font-mono font-bold">{opp.ticket}</p></div>)}
                </div>
                {opp.notes && <p className="text-[11px] text-muted-foreground italic">{opp.notes}</p>}
                <div className="flex gap-1.5 pt-1">
                  <Button variant="ghost" size="sm" className="text-xs gap-1" onClick={() => openDetail(opp)}><Eye className="w-3 h-3" /> Details</Button>
                  <Button variant="ghost" size="sm" className="text-xs gap-1" onClick={() => openEdit(opp)}><Pencil className="w-3 h-3" /> Edit</Button>
                  {opp.url && (<Button variant="ghost" size="sm" className="text-xs gap-1" onClick={() => window.open(opp.url, "_blank")}><ExternalLink className="w-3 h-3" /> View</Button>)}
                  <Button variant="ghost" size="icon" className="ml-auto h-7 w-7" onClick={() => confirmDelete(opp)}><Trash2 className="w-3.5 h-3.5 text-destructive" /></Button>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <Card><CardContent className="py-16 text-center">
          <Landmark className="w-12 h-12 text-muted-foreground mx-auto mb-4" />
          <p className="text-muted-foreground mb-1">No custom opportunities yet</p>
          <p className="text-sm text-muted-foreground mb-5">Create your first opportunity to start tracking deals</p>
          <Button onClick={() => { setFormData(f => ({ ...f, category: "others" })); setIsAddOpen(true); }} disabled={isDemo} className="gap-2" data-testid="others-empty-add-btn"><Plus className="w-4 h-4" /> Add Opportunity</Button>
        </CardContent></Card>
      )}
    </>
  );
};
